import React from "react";
import {NavLink} from "react-router-dom";
import {Card} from "./Card";
import data from "../../card/propieties.json";
/*             <li className="item-target_new">NEW</li>            */
/*                      className="__hiperLink"                                */
import "./target.css";
export function Target(){
  const imagen_loc = { width: "100%" };
  const hiper = { textDecoration: "none" };
  return (
    <div className="container-target" lang="es">
      <section className="section-target-left">
        <article>
          <NavLink to={`/${data[0].route}`} style={hiper}>
            <Card style={imagen_loc} props={data[0]}/><li className="item-target_column"> {data[0].name}</li>
          </NavLink>
        </article>
        <article>
          <NavLink to={`/${data[1].route}`} style={hiper}>
            <Card style={imagen_loc} props={data[1]} /><li className="item-target_column">{data[1].name}</li>
          </NavLink>
        </article>
      </section>
      <section className="section-target-center">
        <article>
          <NavLink to={ `/Super` } style={hiper} >
            <Card style={imagen_loc} props={data[2]} /> <li className="item-target_column">{data[2].name}</li>
          </NavLink>
          </article>
      </section>
      <section className="section-target-right ">
        <article>
          <NavLink to={`/${data[3].route}`} style={hiper}>
            <Card style={imagen_loc} props={data[3]} /> <li className="item-target_column">{data[3].name}</li>
          </NavLink>
        </article>
        <article>
          <NavLink to={`/${data[4].route}`} style={hiper}>
            <Card style={imagen_loc} props={data[4]} /><li className="item-target_column">{data[4].name}</li>
          </NavLink>
        </article>
      </section>
      <section className="section-target-end">
        <article  >
          <NavLink to={`/${data[5].route}`} style={hiper} className="especify" >
            <Card style={imagen_loc} props={data[5]} /><li className="item-target_column">{data[5].name}</li>
          </NavLink>
        </article>
        <article>
          <NavLink to={`/${data[6].route}`} style={hiper}>
            <Card style={imagen_loc} props={data[6]} /><li className="item-target_column">{data[6].name}</li>
          </NavLink>
        </article>
        <article >
          <NavLink to={`/${data[7].route}`} style={hiper}>
            <Card style={imagen_loc} props={data[7]} /><li className="item-target_column">{data[7].name}</li>
          </NavLink>
        </article>
      </section>
    </div>      
  );
}